// Helpers for matching an optimistic (pending) message to the stored copy the
// server sends back, either over the socket echo or in the refetched list.

const HTML_ENTITIES: Record<string, string> = {
  "&nbsp;": " ",
  "&amp;": "&",
  "&lt;": "<",
  "&gt;": ">",
  "&quot;": '"',
  "&#39;": "'",
  "&apos;": "'",
};

/**
 * Reduces message HTML to its visible text. The editor sends HTML, and the
 * server may hand it back re-serialised (entities, whitespace, wrapping tags),
 * so a raw string comparison misses the stored copy of the same message.
 */
export const normalizeMessageContent = (content?: string | null): string =>
  (content ?? "")
    .replace(/<[^>]*>/g, " ")
    .replace(/&(nbsp|amp|lt|gt|quot|apos|#39);/g, (entity) => {
      return HTML_ENTITIES[entity] ?? entity;
    })
    .replace(/&#(\d+);/g, (_, code) => String.fromCharCode(Number(code)))
    .replace(/\s+/g, " ")
    .trim();

export const isSameMessageContent = (
  a?: string | null,
  b?: string | null,
): boolean => normalizeMessageContent(a) === normalizeMessageContent(b);
